// const settingTrade = () =>
//   import(/* webpackChunkName: 'settingTrade' */ '@views/home/setting/settingTrade/index')

// setting
const index = () => import(/* webpackChunkName: 'homeIndex' */ '@views/home/index/index')
const settingMember = () =>
  import(/* webpackChunkName: 'settingMember' */ '@views/home/setting/settingMember/index')
const memberLevelEdit = () =>
  import(/* webpackChunkName: 'settingMember' */ '@views/home/setting/settingMember/memberLevel/levelEdit/edit')
const settingPermission = () =>
  import(/* webpackChunkName: 'settingPermission' */ '@views/home/setting/settingPermission/index')
const permissionDetail = () =>
  import(/* webpackChunkName: 'settingPermission' */ '@views/home/setting/settingPermission/detail/detail')
const settingPosition = () =>
  import(/* webpackChunkName: 'settingPosition' */ '@views/home/setting/settingPosition/index')
const positionEdit = () =>
  import(/* webpackChunkName: 'settingPosition' */ '@views/home/setting/settingPosition/edit/edit')

const Memberstoresettings = () =>
  import(/* webpackChunkName: 'settingTrade' */ '@/views/home/setting/settingMember/Memberstoresettings/Memberstoresettings')

const routes = [
  {
    path: '/setting',
    component: index,
    redirect: { name: 'homeSettingmember' },
    name: 'setting',
    hidden: true,
    meta: {
      keepAlive: true,
      title: '设置',
      icon: 'setting_manage',
      first: true,
      resourceCode: 'SETTING_MANAGE',
      No: 8
    },
    children: [
      {
        path: 'member',
        component: () => import('@components/core/MqlLayout/MqlMiddlePage/index'),
        name: 'homeSettingmember',
        redirect: { name: 'settingMember' },
        meta: {
          keepAlive: true,
          title: '会员设置',
          second: false,
          resourceCode: 'SETTING_MANAGE03',
          No: 0
        },
        children: [
          {
            path: 'memberindex',
            name: 'settingMember',
            component: settingMember,
            meta: {
              keepAlive: true,
              title: '会员设置',
              second: '',
              resourceCode: ''
            }
          },
          {
            path: 'edit/:id',
            name: 'memberLevelEdit',
            component: memberLevelEdit,
            meta: {
              keepAlive: true,
              title: '编辑等级',
              second: '',
              resourceCode: ''
            }
          }
        ]
      },
      {
        path: 'permission',
        component: () => import('@components/core/MqlLayout/MqlMiddlePage/index'),
        name: 'homeSettingPermission',
        redirect: { name: 'settingPermission' },
        meta: {
          keepAlive: true,
          title: '权限组设置',
          second: false,
          resourceCode: 'SETTING_MANAGE04',
          No: 1
        },
        children: [
          {
            path: 'perIndex',
            name: 'settingPermission',
            component: settingPermission,
            meta: {
              keepAlive: true,
              title: '权限组设置',
              second: '',
              resourceCode: ''
            }
          },
          {
            path: 'perSet',
            name: 'permissionDetail',
            component: permissionDetail,
            meta: {
              keepAlive: true,
              title: '权限设置',
              second: '',
              resourceCode: ''
            }
          }
        ]
      },
      {
        path: 'position',
        component: () => import('@components/core/MqlLayout/MqlMiddlePage/index'),
        name: 'homeSettingPosition',
        redirect: { name: 'settingPosition' },
        meta: {
          keepAlive: true,
          title: '职位设置',
          second: false,
          resourceCode: 'SETTING_MANAGE05',
          No: 2
        },
        children: [
          {
            path: 'posIndex',
            name: 'settingPosition',
            component: settingPosition,
            meta: {
              keepAlive: true,
              title: '职位设置',
              second: '',
              resourceCode: ''
            }
          },
          {
            path: 'posSet',
            name: 'positionEdit',
            component: positionEdit,
            meta: {
              keepAlive: true,
              title: '添加职位',
              second: '',
              resourceCode: ''
            }
          }
        ]
      },
      {
        path: 'position',
        component: () => import('@components/core/MqlLayout/MqlMiddlePage/index'),
        name: 'Memberstoresettings',
        redirect: { name: 'Memberstoresettings' },
        meta: {
          keepAlive: true,
          title: '店铺设置',
          second: false,
          resourceCode: 'SETTING_MANAGE06',
          No: 3
        },
        children: [
          {
            path: 'Memberstoresettings',
            name: 'Memberstoresettings',
            component: Memberstoresettings,
            meta: {
              keepAlive: true,
              title: '店铺设置',
              second: '',
              resourceCode: ''
            }
          }
        ]
      }
    ]
  }
]

export default {
  routes
}



// WEBPACK FOOTER //
// ./src/router/home/setting.js